import { useQuery } from "@tanstack/react-query";

import { adminChatApi } from "@/lib/api";
import type { ChatTellersAntwoord } from "@/types/api";

/**
 * Sidebar-tellers Chat/WhatsApp (fixronde 04-08): per kanaal het aantal
 * niet-gesloten gesprekken met ongelezen activiteit. Zelfde ritme als
 * de e-mail-tellers (60s); chat-mutaties invalideren daarnaast de
 * "admin"-querytak zodat de badge direct meebeweegt.
 */
export function useChatTellers(opties?: { enabled?: boolean }) {
  return useQuery<ChatTellersAntwoord>({
    queryKey: ["admin", "chat-tellers"],
    queryFn: () => adminChatApi.tellers(),
    refetchInterval: 60_000,
    // Ook doortellen op een achtergrond-tabblad (08-09): react-query
    // pauzeert zijn interval standaard zodra het document verborgen is,
    // en dan zou de portaalmelding (geluid + titel-teller) juist nooit
    // komen op het moment dat je hem nodig hebt — als je in een ander
    // tabblad zit. Eén licht verzoek per minuut.
    refetchIntervalInBackground: true,
    staleTime: 15_000,
    enabled: opties?.enabled ?? true,
  });
}
